import { render, staticRenderFns } from "./fair.vue?vue&type=template&id=715b7d48&scoped=true&"
import script from "./fair.vue?vue&type=script&lang=js&"
export * from "./fair.vue?vue&type=script&lang=js&"
import style0 from "./fair.vue?vue&type=style&index=0&id=715b7d48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b7d48",
  null
  
)

export default component.exports